import React, { useState, useEffect, useRef, useCallback } from "react";
import "./index.less";
import { Calendar, DatePicker, Pagination, Popover } from "antd";
import { useNavigate } from "react-router-dom";
import { request } from "@/utils/request"
import NavigationBar from "@/components/NavigationBar";
import search from '@/assets/search.png'
import eat from '@/assets/eat.png'
import address from '@/assets/address.png'
import noSearch from '@/assets/noSearch.png'
import Config from "@/config/config";
import { DeleteOutlined, SearchOutlined, SmileOutlined } from '@ant-design/icons';
import gift from '@/assets/gift.png'

import {
    DownOutlined,
    InfoCircleOutlined,
    UpOutlined
} from '@ant-design/icons';
import { convertDateToTimestamp, formatTimestampToDate } from "@/utils/func";
import moment from "moment";

export default function Canteen() {
    const smileIcon = <SmileOutlined />;
    const navigate = useNavigate();
    const [recommend, setRecommend] = useState([])
    const [page, setPage] = useState(1)
    const [cateList, setCateList] = useState([]);
    const [currentType, setCurrentType] = useState(0);
    const [params, setParams] = useState(JSON.parse(sessionStorage.getItem('hw'))?.params || {
        region_id: '',
        category_id: '',
    })
    const [openSet, setOpenSet] = useState({
        region: false,
        type: false,
    })
    const [perPage, setPerPage] = useState(12);
    const [total, setTotal] = useState(0)
    const listRef = useRef(null);

    const fetchData = async (page, perPage, name = '', category_id = '', reservation_date_confirm = '') => {
        try {
            let url = 'goodseat/list_by_date' + `?page=${page}&per-page=${perPage}`;
            if (name) {
                url += "&name=" + name
            }
            if (category_id) {
                url += "&category_id=" + category_id
            }
            if (reservation_date_confirm) {
                url += "&reservation_date_confirm=" + convertDateToTimestamp(reservation_date_confirm)
            }
            const response = await request.get(url);
            let data = response.data
            // setRecommend(data)
            // reservation_date_confirm;
            const groupedMap = new Map();
            const currentTime = Math.floor(new Date().getTime() / 1000);
            let goodseatListCopy = [...data];
            // let goodseatListCopy2 = goodseatListCopy.filter(v => convertDateToTimestamp(`${formatTimestampToDate(v.reservation_date_confirm)} ${v.reservation_time_confirm}`) >= currentTime).filter(v => (v.raffle_status == 1 && v.raffle == 1) || (v.raffle_status == 0 && v.raffle == 0));
            // goodseatListCopy2?.forEach(item => {
            //     const date = item.reservation_date_confirm;
            //     if (!groupedMap.has(date)) {
            //         groupedMap.set(date, []);
            //     }
            //     groupedMap.get(date).push(item);
            // });
            // const groupedObj = Object.fromEntries(groupedMap);
            // let newList = []
            // Object.keys(groupedObj).forEach((key, value) => {
            //     const date = key;
            //     const list = groupedObj[key];
            //     newList.push({
            //         date: date,
            //         list: list,
            //     })
            // })
            // console.log(newList, 'newList')
            setRecommend([...goodseatListCopy])
            setTotal(response._meta.totalCount)
            console.log(currentDate.current, 'currentDate')
            if (currentDate.current == null) {
                params.reservation_date_confirm = ''
            }
            sessionStorage.setItem("hw", JSON.stringify({ selectVal, params, currentDate: currentDate.current }))
            if (name) {
                // 过滤掉 searchHistory 中已存在的搜索词，然后将新的搜索词添加到数组开头
                const newSearchHistory = [name, ...searchHistory.filter(item => item !== name)];
                setSearchHistory(newSearchHistory);
                localStorage.setItem('hwHis', JSON.stringify(newSearchHistory));
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    useEffect(() => {
        // listRef.current.scrollIntoView({ behavior: "smooth" })
        if (listRef.current) {
            window.scrollTo(0, 0)
        }
    }, [recommend])


    const pageChange = (e, v) => {

        setPage(e)
        setPerPage(v)
        fetchData(e, v)
    };

    const doSearch = (val) => {
        // fetchData(0, perPage, val)
        console.log(val)
        // fetchData(0,perPage,val)
        navigate('/search?name=' + val)
    }

    const changeType = (val, index) => {
        selectVal.type = val.name
        setSelectVal({ ...selectVal })
        setCurrentType(index)
        params.category_id = val.id
        setParams({ ...params })
        openSet.type = false
        setOpenSet({ ...openSet })
        fetchData(page, perPage, params.name, params.category_id, params.reservation_date_confirm);
    }


    const getCateList = async () => {
        // restaurant/category-list
        const reponse = await request.get('restaurant/category-list?page=1&per-page=100', {});
        reponse.data.unshift({
            id: "",
            name: "全部"
        })
        reponse.data?.map((v,i) => {
            if (v.name == selectVal.type) {
                setCurrentType(i)
            }
        })
        setCateList(reponse.data)
    }
    useEffect(() => {
        sessionStorage.setItem("mbx", "transfer")
        getCateList()
        fetchData(page, perPage, params.name, params.category_id, params.reservation_date_confirm);

    }, []);
    const [searchHistory, setSearchHistory] = useState(JSON.parse(localStorage.getItem('hwHis')) || []);
    const currentDate = useRef((JSON.parse(sessionStorage.getItem('hw'))?.currentDate && moment(JSON.parse(sessionStorage.getItem('hw'))?.currentDate)) || null)
    const selectDate = (date, dateString) => {
        console.log(date, dateString)
        currentDate.current = date
        if (date == null) {
            setParams({ ...params, reservation_date_confirm: '' })
            fetchData(page, perPage, params.name, params.category_id, '');
            return
        }
        params.reservation_date_confirm = dateString + ' 00:00:00'
        setParams({ ...params })
        fetchData(page, perPage, params.name, params.category_id, dateString + ' 00:00:00');

    }
    const [selectVal, setSelectVal] = useState(JSON.parse(sessionStorage.getItem('hw'))?.selectVal || {})
    const resetSearchHistory = () => {
        localStorage.removeItem('ctHis')
        setSearchHistory([])
    }
    const handleHistorySearch = (item) => {
        params.name = item
        setParams({ ...params })
        fetchData(page, perPage, item, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids);
    }
    // 定义一个变量用于存储定时器 ID
    let timeoutId = null;
    const nameSearch = (e) => {
        e.stopPropagation();
        params.name = e.target.value
        setParams({ ...params })
        // 清除之前的定时器
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            fetchData(page, perPage, e.target.value, params.category_id, params.reservation_date_confirm);
        }, 1000);

    }

    const SearchHistoryComp = () => {
        return (
            <>
                <div className="search-history-box">
                    <div className="search-history-box-item-head">
                        <div className="search-history-box-item-head-left">历史记录</div>
                        <div className="search-history-box-item-head-right"
                            onClick={resetSearchHistory}
                        >
                            <DeleteOutlined /></div>
                    </div>
                    <div className="search-history-box-content">
                        {searchHistory.map((item) => {
                            return (
                                <div className="search-history-list-item" onClick={() => {
                                    handleHistorySearch(item)
                                }}>
                                    <div className="search-history-list-item-icon">
                                        <SearchOutlined />
                                    </div>
                                    <span className="search-history-item-text">
                                        {item}
                                    </span>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </>
        )
    }
    return (
        <div className="transfer" ref={listRef} onClick={() => {
            console.log('lijiao')
            openSet.date = false
            openSet.type = false
            setOpenSet({ ...openSet })
        }}>
            <NavigationBar showNavRight={true} showNavTabs={true} showSearch={true}
                onSearchChange={doSearch}></NavigationBar>
            <div className="transfer-heart" >
                <div className="search-content">
                    <div className="search-title">筛选餐厅</div>
                    <div className='search-tool'>
                        <Popover placement="bottom" content={SearchHistoryComp} title=""
                            style={{ borderRadius: "8px" }}>
                            <div className='search-input'>
                                <img src={search} alt="" className='searchIcon' />
                                <input placeholder="搜索餐厅名称" value={params.name} onInput={(e) => {
                                    nameSearch(e)
                                }} />
                            </div>
                        </Popover>
                        <div className='search-select'>
                            <div className='select-moudle-transfer'
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openSet.type = false
                                    openSet.data = !openSet.data
                                    setOpenSet({ ...openSet })
                                }}>
                                {/* <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={date} alt="" className='icon' />
                                        <div>预约时间</div>
                                        
                                    </div>
                                    {
                                        openSet.data ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div> */}
                                <DatePicker
                                    placeholder="预约时间"
                                    format={"YYYY-MM-DD"}
                                    renderExtraFooter={() =>
                                        <div style={{ color: '#C59D60', cursor: 'pointer' }} onClick={() => {
                                            params.reservation_date_confirm = ''
                                            currentDate.current = null
                                            setParams({ ...params })
                                            fetchData(page, perPage, params.name, params.category_id, '')
                                            sessionStorage.setItem("hw", JSON.stringify({ selectVal, params, currentDate: null }))
                                        }}>清除</div>
                                    }

                                    value={currentDate.current}
                                    suffixIcon={<DownOutlined />}
                                    picker="date" onChange={selectDate} />
                                {/* {
                                    openSet.data && <div className='select-mask-type'>
                                        <div className='all'>
                                            <Calendar
                                                fullscreen={false}
                                                headerRender={({ value, type, onChange, onTypeChange }) => {
                                                    return (
                                                        <div style={{ padding: 8 }}>
                                                            {/* <Typography.Title level={4}>Custom header</Typography.Title> */}

                                {/* </div>
                                                    );
                                                }}
                                            // onPanelChange={onPanelChange}
                                            />
                                        </div>
                                    </div>
                                } */}
                            </div>
                            <div className='select-moudle-transfer'
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openSet.data = false
                                    openSet.type = !openSet.type
                                    setOpenSet({ ...openSet })
                                }}>
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={eat} alt="" className='icon' />
                                        <div className='select-type'>{selectVal.type || '餐厅类型'}</div>
                                    </div>
                                    {
                                        openSet.type ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.type && <div className='select-mask-type'>
                                        <div className='all'>
                                            <div >{
                                                cateList?.map((v, i) => {
                                                    return <div
                                                        className={`all-item ${currentType == i ? 'active' : ''}`}
                                                        onClick={() => { changeType(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div className="type-transfer" >
                    <div className="transfer-content">
                        {
                            recommend.length > 0 ? <>
                                {
                                    recommend.map((item, idx) => {
                                        return (
                                            // 如果你想在 style 属性中添加更多判断，可以使用三元运算符或者对象合并的方式。以下是一个修改后的代码示例，它根据 idx 是否为 4 的倍数来设置 marginRight 属性：
                                            <div key={item.id} className='transfer-item'>
                                                <div className='transfer-date'> {formatTimestampToDate(item.reservation_date_confirm, 'day')}</div>
                                                {
                                                    item?.restaurant_list?.map((v, i) => {
                                                        return <div className='transfer-items' onClick={(e) => {
                                                            e.stopPropagation()
                                                            navigate('/transferDetail?id=' + v.id)
                                                        }
                                                        }>
                                                            <div className="coverImg">
                                                                <img
                                                                    objectFit="cover"
                                                                    src={Config.imgPrefix + v.covers.split("||")[0]}
                                                                    className="cover" alt="" />
                                                                {
                                                                    !!v.raffle && <img
                                                                        src={gift}
                                                                        className="icon" alt="" />
                                                                }
                                                            </div>
                                                            <div className="info">
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                                                    <div className="seats"><span>{formatTimestampToDate(v.reservation_date_confirm)}   {v.reservation_time_confirm}</span></div>
                                                                    <div>
                                                                        {
                                                                            !v.raffle && v.reservation_number_confirm == v.buy_seats_amount &&
                                                                            <div className="null">已售罄</div>
                                                                        }
                                                                        {
                                                                            !v.raffle && v.reservation_number_confirm > v.buy_seats_amount && <>
                                                                                {
                                                                                    convertDateToTimestamp(`${formatTimestampToDate(v?.reservation_date_confirm)} ${v?.reservation_time_confirm}`) > Math.floor(new Date().getTime() / 1000)
                                                                                        ? (
                                                                                            <div className="hasseat" style={{ color: '#C59D60' }}>可预订</div>
                                                                                        ) : (
                                                                                            <div className="null">已过期</div>
                                                                                        )
                                                                                }
                                                                            </>
                                                                        }

                                                                        {/* 抽奖好位 */}
                                                                        {
                                                                            !!v.raffle && v.raffle_status == 0 &&
                                                                            <div className="hasseat" style={{ color: '#C59D60' }}>待开放</div>
                                                                        }
                                                                        {
                                                                            !!v.raffle && v.raffle_status == 1 &&
                                                                            <div className="raffleing" style={{ color: '#EA0025' }}>抽奖招募中</div>
                                                                        }
                                                                        {
                                                                            !!v.raffle && v.raffle_status == 2 &&
                                                                            <div className="null">抽奖结束</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="name">{v.name}</div>
                                                                <div className="feature">主题：{v.title}</div>
                                                                <div className="seats"><span>空位：{v.reservation_number_confirm - v?.buy_seats_amount}/{v?.reservation_number_confirm}</span></div>
                                                                {/* <div className="desc" dangerouslySetInnerHTML={{ __html: v?.text_description?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}></div> */}
                                                                <div className="prices">
                                                                    <div className="amount"><span style={{ fontSize: '12px' }}>位费￥</span><span style={{ fontSize: '18px' }}>{v?.subscription_price}</span></div>
                                                                    <div className="desposite">押金￥{v?.meal_deposit}/人</div>
                                                                </div>
                                                                {
                                                                    v?.note && <div className="tip"><InfoCircleOutlined /><span style={{ marginLeft: '10px' }}>{v?.note}</span></div>
                                                                }

                                                            </div>
                                                        </div>
                                                    })
                                                }

                                            </div>
                                        )
                                    })
                                }
                            </> :
                                <div className='no-data'>
                                    <img src={noSearch} alt="" srcset="" className='searchIcon' />
                                    <div className='no-data-tip'>没有搜索结果</div>
                                </div>
                        }
                    </div>
                    <div className="pagination-box">
                        <Pagination
                            className='main-pagination'
                            total={total}
                            pageSize={perPage}
                            pageSizeOptions={[12, 24, 36, 48]}
                            onChange={pageChange}
                            showQuickJumper
                            showTotal={(total) => `共${total}条`}
                            current={page}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
